import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const SchememasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		schemeid: yup.string().required().label($t('schemeid')),
		schemename: yup.string().required().label($t('schemename')),
		description: yup.string().required().label($t('description')),
		applicablefrom: yup.string().required().label($t('applicablefrom')),
		applicableto: yup.string().required().label($t('applicableto')),
		calcbasedon: yup.string().required().label($t('calcbasedon')),
		calcmethod: yup.string().nullable().label($t('calcmethod')),
		paymentfrequency: yup.string().nullable().label($t('paymentfrequency')),
		compounded: yup.string().required().label($t('compounded')),
		paymenttoadvance: yup.number().required().label($t('paymenttoadvance')),
		preclosuremindays: yup.number().required().label($t('preclosuremindays')),
		penaltytype: yup.string().required().label($t('penaltytype')),
		penalty: yup.number().required().label($t('penalty')),
		minloanamount: yup.number().required().label($t('minloanamount')),
		maxloanamount: yup.number().required().label($t('maxloanamount')),
		loanperiod: yup.number().required().label($t('loanperiod')),
		maxapproval: yup.number().required().label($t('maxapproval')),
		processingfee: yup.number().required().label($t('processingfee')),
		interestrate: yup.number().nullable().label($t('interestrate')),
		insurancefee: yup.number().nullable().label($t('insurancefee'))
	});
	// form default values
	const formDefaultValues = {
		schemeid: '', 
		schemename: '', 
		description: '', 
		applicablefrom: new Date(), 
		applicableto: new Date(), 
		calcbasedon: '', 
		calcmethod: '', 
		paymentfrequency: '', 
		compounded: "((0))", 
		paymenttoadvance: '', 
		preclosuremindays: '', 
		penaltytype: '', 
		penalty: '', 
		minloanamount: '', 
		maxloanamount: '', 
		loanperiod: '', 
		maxapproval: '', 
		processingfee: "((0))", 
		interestrate: '', 
		insurancefee: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/schememaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="SchememasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editSchememaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('schemeid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="schemeid"  onChange={formik.handleChange}  value={formik.values.schemeid}   label={$t('schemeid')} type="text" placeholder={$t('enterSchemeid')}        className={inputClassName(formik?.errors?.schemeid)} />
                                                <ErrorMessage name="schemeid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('schemename')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="schemename"  onChange={formik.handleChange}  value={formik.values.schemename}   label={$t('schemename')} type="text" placeholder={$t('enterSchemename')}        className={inputClassName(formik?.errors?.schemename)} />
                                                <ErrorMessage name="schemename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('description')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="description"  onChange={formik.handleChange}  value={formik.values.description}   label={$t('description')} type="text" placeholder={$t('enterDescription')}        className={inputClassName(formik?.errors?.description)} />
                                                <ErrorMessage name="description" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('applicablefrom')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="applicablefrom" showButtonBar className={inputClassName(formik?.errors?.applicablefrom)} dateFormat="yy-mm-dd" value={formik.values.applicablefrom} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="applicablefrom" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('applicableto')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="applicableto" showButtonBar className={inputClassName(formik?.errors?.applicableto)} dateFormat="yy-mm-dd" value={formik.values.applicableto} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="applicableto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('calcbasedon')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="calcbasedon"  onChange={formik.handleChange}  value={formik.values.calcbasedon}   label={$t('calcbasedon')} type="text" placeholder={$t('enterCalcbasedon')}        className={inputClassName(formik?.errors?.calcbasedon)} />
                                                <ErrorMessage name="calcbasedon" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('calcmethod')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="calcmethod"  onChange={formik.handleChange}  value={formik.values.calcmethod}   label={$t('calcmethod')} type="text" placeholder={$t('enterCalcmethod')}        className={inputClassName(formik?.errors?.calcmethod)} />
                                                <ErrorMessage name="calcmethod" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paymentfrequency')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentfrequency"  onChange={formik.handleChange}  value={formik.values.paymentfrequency}   label={$t('paymentfrequency')} type="text" placeholder={$t('enterPaymentfrequency')}        className={inputClassName(formik?.errors?.paymentfrequency)} />
                                                <ErrorMessage name="paymentfrequency" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('compounded')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="compounded"  onChange={formik.handleChange}  value={formik.values.compounded}   label={$t('compounded')} type="text" placeholder={$t('enterCompounded')}        className={inputClassName(formik?.errors?.compounded)} />
                                                <ErrorMessage name="compounded" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paymenttoadvance')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymenttoadvance"  onChange={formik.handleChange}  value={formik.values.paymenttoadvance}   label={$t('paymenttoadvance')} type="number" placeholder={$t('enterPaymenttoadvance')}  min={0}  step="any"    className={inputClassName(formik?.errors?.paymenttoadvance)} />
                                                <ErrorMessage name="paymenttoadvance" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('preclosuremindays')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="preclosuremindays"  onChange={formik.handleChange}  value={formik.values.preclosuremindays}   label={$t('preclosuremindays')} type="number" placeholder={$t('enterPreclosuremindays')}  min={0}  step="any"    className={inputClassName(formik?.errors?.preclosuremindays)} />
                                                <ErrorMessage name="preclosuremindays" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('penaltytype')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="penaltytype"  onChange={formik.handleChange}  value={formik.values.penaltytype}   label={$t('penaltytype')} type="text" placeholder={$t('enterPenaltytype')}        className={inputClassName(formik?.errors?.penaltytype)} />
                                                <ErrorMessage name="penaltytype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('penalty')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="penalty"  onChange={formik.handleChange}  value={formik.values.penalty}   label={$t('penalty')} type="number" placeholder={$t('enterPenalty')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.penalty)} />
                                                <ErrorMessage name="penalty" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('minloanamount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="minloanamount"  onChange={formik.handleChange}  value={formik.values.minloanamount}   label={$t('minloanamount')} type="number" placeholder={$t('enterMinloanamount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.minloanamount)} />
                                                <ErrorMessage name="minloanamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maxloanamount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="maxloanamount"  onChange={formik.handleChange}  value={formik.values.maxloanamount}   label={$t('maxloanamount')} type="number" placeholder={$t('enterMaxloanamount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.maxloanamount)} />
                                                <ErrorMessage name="maxloanamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanperiod')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanperiod"  onChange={formik.handleChange}  value={formik.values.loanperiod}   label={$t('loanperiod')} type="number" placeholder={$t('enterLoanperiod')}  min={0}  step="any"    className={inputClassName(formik?.errors?.loanperiod)} />
                                                <ErrorMessage name="loanperiod" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maxapproval')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="maxapproval"  onChange={formik.handleChange}  value={formik.values.maxapproval}   label={$t('maxapproval')} type="number" placeholder={$t('enterMaxapproval')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.maxapproval)} />
                                                <ErrorMessage name="maxapproval" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('processingfee')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="processingfee"  onChange={formik.handleChange}  value={formik.values.processingfee}   label={$t('processingfee')} type="number" placeholder={$t('enterProcessingfee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.processingfee)} />
                                                <ErrorMessage name="processingfee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interestrate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interestrate"  onChange={formik.handleChange}  value={formik.values.interestrate}   label={$t('interestrate')} type="number" placeholder={$t('enterInterestrate')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.interestrate)} />
                                                <ErrorMessage name="interestrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('insurancefee')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="insurancefee"  onChange={formik.handleChange}  value={formik.values.insurancefee}   label={$t('insurancefee')} type="number" placeholder={$t('enterInsurancefee')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.insurancefee)} />
                                                <ErrorMessage name="insurancefee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
SchememasterEditPage.defaultProps = {
	primaryKey: 'schemeid',
	pageName: 'schememaster',
	apiPath: 'schememaster/edit',
	routeName: 'schememasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default SchememasterEditPage;
